export default __webpack_public_path__ + "static/media/uslugi-logo.cbde7368.svg";